enum ChatFailureType {
  BUSY = "busy", //                          409 — a turn is already running on this conversation
  CONVERSATION_GONE = "conversationGone", // 404 — the conversation id is unknown or not ours
  NETWORK = "network", //                    no response at all
  RESTORED = "restored", //                  was still sending when the tab reloaded
  UNAVAILABLE = "unavailable", //            502 — the AI service is down
  UNKNOWN = "unknown",
  VALIDATION = "validation", //              400
}

export default ChatFailureType;
